<div class="text-limiter">
  <div class="text-limiter__text">
    {{ textView }}
    <info-tooltip
      [tooltip]="tooltip"
      *ngIf="showTooltip && tooltip"
    ></info-tooltip>
  </div>
</div>
